import { CallHistoryModel } from 'one-card-call-history';

import { SET, INIT } from './types';

import { Actions } from './actions';

/**
 *
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const callHistory = (
    context: any,
    initial?: CallHistoryModel,
) => {
    let initialstate = initial || {};
    return (
        state: CallHistoryModel,
        action: Actions,
    ) => {
        const { type, payload } = action;
        let updated = state || initialstate;

        switch (type) {
            case SET:
                updated = {
                    ...updated,
                    callHistoryData: payload.callHistoryData,
                    status: payload.status
                };
                break;
            case INIT:
                updated = {
                    ...initialstate
                }
                break;
        }
        return updated;
    }
};
